export const state = {
  me: {},
  users: [],
  roles: [],
  roleAssignments: [],
  vehicleOwners: [],
  yellowfinToken: '',
  yellowfinRedirectUrl: '',
};
